import { render, staticRenderFns } from "./FlexmessageButtonAction.vue?vue&type=template&id=5c17fafb&scoped=true&"
import script from "./FlexmessageButtonAction.vue?vue&type=script&lang=js&"
export * from "./FlexmessageButtonAction.vue?vue&type=script&lang=js&"
import style0 from "./FlexmessageButtonAction.vue?vue&type=style&index=0&id=5c17fafb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c17fafb",
  null
  
)

export default component.exports